<template>
	<div>
		<div v-if="!visualizar">
			<div class="no-print">
				<div v-if="!modal && cabecalho" class="fl-cabecalho no-print">
					<div class="row">
						<div class="col-xs-12 col-md-3">
							<i class="icon icon-desapacho_aeronaves"></i>
							<h3>{{ _traducao('global', 'despacho').toUpperCase() }}</h3>
							<h4>{{ _traducao('menuMonitoramento', 'menuMonitoraAeronaves').toUpperCase() }}</h4>
						</div>

						<div class="col-md-5 col-xs-12">
							<span v-if="form.id == 0">
								<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
								<h3>{{ _traducao('global', 'novo') }}</h3>
							</span>

							<span v-if="form.id != 0">
								<i class="icon icon-editar icon-sub"></i>
								<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
							</span>

							<h4>{{ _traducao('global', 'despacho').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<button @click="voltaLista()" :title="_traducao('global', 'voltar')" class="btn btn-default pull-right btn-lg">
								<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
							</button>

							<button
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								v-show="form.id != 0"
								style="margin-right: 20px"
								type="button"
								@click="clickPrint(0)"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button>
						</div>
					</div>
				</div>

				<div v-if="form.numero != ''">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'codigoSituacao')" />

					<div class="row">
						<div class="col-xs-12">
							<p style="margin-bottom: 0px; margin-top: 6px">
								{{ form.numero }} -
								<span v-if="form.status == 'A'">{{ _traducao('global', 'aberta').toUpperCase() }}</span>
								<span v-if="form.status == 'E'">{{ _traducao('global', 'encerrada').toUpperCase() }}</span>
							</p>
						</div>
					</div>
				</div>
				<div>
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'tipoDespacho')" />
				</div>

				<div class="row">
					<div class="col-md-3 col-xs-12" v-if="_getPrivilegio(106) && _prevencao_qualificada">
						<button
							type="button"
							@click="clickSetaTipo('Q')"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'Q'}"
						>
							{{ _traducao('global', 'preventiva').toUpperCase() }}
							<i v-show="form.tipo == 'Q'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<div class="col-md-3 col-xs-12">
						<button
							type="button"
							@click="clickSetaTipo('E')"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'E'}"
						>
							{{ _traducao('global', 'emergencial').toUpperCase() }}
							<i v-show="form.tipo == 'E'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<div class="col-md-3 col-xs-12" v-show="_idCliente != 18">
						<button
							type="button"
							@click="clickSetaTipo('C')"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'C'}"
						>
							{{ _traducao('global', 'critica').toUpperCase() }}
							<i v-show="form.tipo == 'C'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<div class="col-md-3 col-xs-12">
						<button
							type="button"
							@click="clickSetaTipo('P')"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'P'}"
						>
							{{ _traducao('global', 'planejada').toUpperCase() }}
							<i v-show="form.tipo == 'P'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
				</div>

				<div v-show="form.tipo == 'P'">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'ordemDeMissao')" />

					<div class="row">
						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'ordemDeMissao') }}:</label>
							<br />
							<p>{{ form.ordem_codigo | na }}</p>
						</div>

						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'data') }}:</label>
							<br />
							<p>{{ form.ordem_data_inicio | dataTempo | na }}</p>
						</div>

						<div class="col-md-4 col-xs-12">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ form.ordem_descricao | na }}</p>
						</div>
					</div>
				</div>

				<div v-show="form.tipo == 'Q'">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="'Prevenção Qualificada'" />
					<div class="row">
						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'prevencaoDespacho') }}:</label>
							<br />
							<p>{{ form.prevencao_codigo | na }}</p>
						</div>

						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'inicio') }}:</label>
							<br />
							<p>{{ form.prevencao_inicio | dataTempo | na }}</p>
						</div>
						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'fim') }}:</label>
							<br />
							<p>{{ form.prevencao_fim | dataTempo | na }}</p>
						</div>

						<div class="col-md-4 col-xs-12">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ form.prevencao_descricao | na }}</p>
						</div>
					</div>
				</div>

				<div v-if="this.form.tipo != ''">
					<div v-if="form.tipo == 'E'">
						<flCabecalhoForm
							:msg="_traducao('global', 'obrigatorio')"
							cls="print-titulo-form-20"
							:texto="_traducao('global', 'solicitaUsoAeronave')"
						/>

						<div class="row">
							<div class="col-xs-12">
								<button class="btn btn-sm btn-info" @click="clickAddSolicitacao()">
									<span v-if="form.id_solicitacao == ''"
										><i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionar').toUpperCase() }}</span
									>
									<span v-if="form.id_solicitacao != ''"
										><i class="fa fa-fw fa-refresh"></i>{{ _traducao('global', 'alterar').toUpperCase() }}</span
									>
								</button>
							</div>
						</div>

						<div class="row" style="margin-top: 15px" v-if="form.id_solicitacao != '' && form.tipo == 'E'">
							<div class="col-xs-2">
								<strong>{{ _traducao('global', 'codigo') }}:</strong><br />
								{{ form.solicitacao_codigo }}
							</div>

							<div class="col-xs-10">
								<strong>{{ _traducao('global', 'descricao') }}:</strong><br />
								{{ form.solicitacao_descricao }}
							</div>
						</div>
					</div>

					<flCabecalhoForm
						:msg="_traducao('global', 'obrigatorio')"
						cls="print-titulo-form-20"
						:texto="_traducao('global', 'dadosDoDespacho')"
					/>

					<div class="row">
						<div class="col-md-3 col-xs-12 form-group" :class="{'has-error': erro.data_inicio}">
							<label>* {{ _traducao('global', 'dataAbertura') }}:</label>
							<flDateTime
								@v-model="(val) => (form.data_inicio = val)"
								:value="form.data_inicio"
								:lang="_getLangDp"
								:placeholder="_formatDate + ' HH:MM'"
								name="teste"
								:format="_formatDate + ' HH:mm'"
							/>
							<p class="help-block" v-if="erro.data_inicio">{{ erro.data_inicio }}</p>
						</div>

						<div class="col-md-3 col-xs-12 form-group" v-show="form.tipo !== 'P'">
							<label>{{ _traducao('global', 'horarioApresentacaoTripulacao') }}:</label>
							<flDateTime
								@v-model="(val) => (form.data_hora_apresentacao = val)"
								:value="form.data_hora_apresentacao"
								:lang="_getLangDp"
								:placeholder="_formatDate + ' HH:MM'"
								name="teste"
								:format="_formatDate + ' HH:mm'"
							/>
						</div>

						<div
							class="col-md-4 col-xs-12 form-group"
							v-show="form.tipo !== 'Q' && _idCliente != 18"
							:class="{'has-error': erro.numero_chamada}"
						>
							<label>* Nº {{ _traducao('global', 'chamada') }}:</label>
							<input
								type="text"
								class="form-control input-sm"
								placeholder="0000-00000000-0"
								v-mask="'0000-00000000-0'"
								v-model="form.numero_chamada"
							/>
							<p class="help-block" v-if="erro.numero_chamada">{{ erro.numero_chamada }}</p>
						</div>

						<div
							class="col-md-4 col-xs-12 form-group"
							v-show="form.tipo !== 'Q' && _idCliente != 18"
							:class="{'has-error': erro.numero_bo}"
						>
							<label>Nº REDS:</label>
							<input
								type="text"
								class="form-control input-sm"
								placeholder="0000-000000000-000"
								v-mask="'0000-000000000-000'"
								v-model="form.numero_bo"
							/>
						</div>
					</div>

					<div class="row">
						<!-- MISSÃO -->
						<div class="col-xs-12 form-group" v-show="form.tipo !== 'P'">
							<label>{{ _traducao('global', 'missao') }}:</label>
							<select v-model="form.id_tipo_missao" class="form-control input-sm">
								<option value="0">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
								<option v-for="tipoMissao in tipos_missao" :key="tipoMissao.descricao" :value="tipoMissao.id">
									{{ tipoMissao.descricao }}
								</option>
							</select>
						</div>
					</div>

					<!-- CLASSIFICACAO E SUB -->
					<div class="row">
						<div class="col-xs-12 col-md-12 form-group" :class="{'has-error': erro.subclassificacao != ''}">
							<label>* {{ _traducao('global', 'classificacaoESub') }}:</label>
							<v-select
								v-model="form.subclassificacao"
								class="form-control input-sm"
								:options="subclassificacoes"
								label="_descricao"
							></v-select>
							<p class="help-block" v-if="erro.subclassificacao != ''">{{ erro.subclassificacao }}</p>
						</div>
					</div>

					<!-- CONTEXTO OPERATIVO -->
					<div>
						<div class="row">
							<div class="col-xs-12 form-group" :class="{'has-error': erro.houve_contexto != ''}">
								<label>* {{ _traducao('global', 'haContextoOperativo') }}</label> <br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.houve_contexto = '1'
											erro.houve_contexto = ''
										"
										:class="{'btn-info': form.houve_contexto == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.houve_contexto = '0'
											erro.houve_contexto = ''
										"
										:class="{'btn-info': form.houve_contexto == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.houve_contexto != ''">{{ erro.houve_contexto }}</p>
							</div>
						</div>
						<div class="row" v-if="form.houve_contexto == '1'">
							<div class="col-xs-12 col-md-6 form-group" :class="{'has-error': erro.contexto_operativo != ''}">
								<label>* {{ _traducao('global', 'contextoOperativo') }}</label>
								<v-select
									v-model="form.contexto_operativo"
									class="form-control input-sm"
									:options="contextos"
									label="descricao"
								></v-select>
								<p class="help-block" v-if="erro.contexto_operativo != ''">{{ erro.contexto_operativo }}</p>
							</div>
						</div>
					</div>

					<!-- HISTÓRICO -->
					<div>
						<div class="row">
							<div class="col-xs-12 form-group" :class="{'has-error': erro.historico != ''}">
								<label>* {{ _traducao('global', 'historico') }}:</label>
								<textarea rows="4" class="form-control input-sm" v-model="form.historico"></textarea>
								<p class="help-block" v-if="erro.historico != ''">{{ erro.historico }}</p>
							</div>
						</div>
					</div>

					<!-- AERONAVES -->
					<div>
						<div v-for="(item, index) in form.aeronave" :key="index">
							<div class="row">
								<div :class="{'has-error': item.erro != ''}" class="col-md-4 col-xs-12 form-group" style="margin-bottom: 10px">
									<label>* {{ _traducao('global', 'aeronave') }} {{ index + 1 }}: </label>
									<span class="pull-right" v-show="index > 0">
										<a
											href="#"
											:disabled="id_aeronave == item.id_aeronave"
											style="color: red"
											@click.prevent="form.aeronave.splice(index, 1)"
											type="button"
											><i class="fa fa-fw fa-trash"></i>{{ _traducao('global', 'remover').toUpperCase() }}</a
										>
									</span>
									<select
										class="form-control input-sm"
										@change="addTripulacao(index)"
										:disabled="id_aeronave == item.id_aeronave"
										v-model="item.id_aeronave"
									>
										<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
										<option v-for="item in aeronaves" v-show="_exibeAeroOrgao(item)" :value="item.id" :key="item.id">
											{{ item.codinome }} - {{ item.prefixo }}
										</option>
									</select>
									<p class="help-block" v-if="item.erro != ''">{{ item.erro }}</p>
								</div>

								<!-- BASE -->
								<div class="col-md-2 col-xs-12 form-group" :class="{'has-error': item.erroBase != ''}">
									<label>* {{ _traducao('global', 'base') }}:</label>
									<select v-model="item.base" class="form-control input-sm">
										<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
										<option v-for="item in bases" :key="item.descricao" :value="item.id">{{ item.descricao }}</option>
									</select>
									<p class="help-block" v-if="item.erroBase">{{ item.erroBase }}</p>
								</div>
							</div>

							<div class="row" v-for="(trip, idxTrip) in item.tripulacao" :key="trip.id">
								<div v-if="item.id_aeronave != ''">
									<div class="col-md-1 col-xs-1"></div>

									<div class="col-md-4 col-xs-11 form-group" :class="{'has-error': trip.erroFuncao != ''}">
										<label>{{ _traducao('global', 'funcao') }}:</label>
										<select v-show="idxTrip == 0" class="form-control input-sm" v-model="item.voo_instrucao">
											<option value="0">{{ _traducao('global', 'pilotoComando').toUpperCase() }}</option>
											<option value="1">{{ _traducao('global', 'instrutorVoo').toUpperCase() }}</option>
										</select>
										<select
											v-show="idxTrip > 0"
											@change="carregaUsuariosTripulacao(index, idxTrip, trip.funcao, true)"
											class="form-control input-sm"
											v-model="trip.funcao"
										>
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option value="Piloto em Instrução">{{ _traducao('global', 'pilotoInstrucao').toUpperCase() }}</option>
											<option value="Copiloto">{{ _traducao('global', 'copiloto').toUpperCase() }}</option>
											<option value="Mecânico">{{ _traducao('global', 'mecanico').toUpperCase() }}</option>
											<option value="Operador Aerotático">{{ _traducao('global', 'operadorAerotatico').toUpperCase() }}</option>
											<option value="TAS">TAS</option>
											<option value="Estagiário">{{ _traducao('global', 'estagiario').toUpperCase() }}</option>
										</select>
										<p class="help-block" v-if="trip.erroFuncao">{{ trip.erroFuncao }}</p>
									</div>

									<div v-if="_isMobile" class="col-xs-1"></div>

									<div class="col-md-5 col-xs-11 form-group" :class="{'has-error': trip.erroTrigrama != ''}">
										<label>{{ _traducao('global', 'nome') }}:</label>
										<small v-show="idxTrip == 0 && form.voo_instrucao == 0" class="text-info pull-right"
											><i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'obrigPilotoComando') }}</small
										>
										<small v-show="idxTrip == 0 && form.voo_instrucao == 1" class="text-info pull-right"
											><i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'obrigInstrutorVoo') }}</small
										>
										<select
											v-if="_isMobile"
											v-model="trip.trigrama"
											@blur="setaNomeTripulanteTrigrama(index, idxTrip, trip.usuarios, trip.trigrama)"
											class="form-control input-sm"
										>
											<option v-for="(usr, idx) in trip.usuarios" :key="idx" :value="usr.trigrama">
												{{ usr.trigrama }} - {{ usr.nome }}
											</option>
										</select>

										<flSelect
											:list="trip.usuarios"
											:value="trip.trigrama == '' ? '' : trip.trigrama + ' - ' + trip.nome"
											v-show="!trip.load"
											v-if="!_isMobile"
											@v-model="(input) => setaNomeTripulanteTrigrama(index, idxTrip, trip.usuarios, input)"
											:return="'trigrama'"
											:label="'descricao'"
										/>

										<flCarregando v-show="trip.load" />
										<p class="help-block" v-if="trip.erroTrigrama">{{ trip.erroTrigrama }}</p>
									</div>

									<div v-if="_isMobile" class="col-xs-1"></div>

									<div class="col-md-2 col-xs-11 form-group">
										<label v-show="!_isMobile" style="color: #f9f9f9">teste:</label>
										<button
											v-show="idxTrip != 0"
											class="btn btn-sm btn-block btn-danger"
											type="button"
											@click="item.tripulacao.splice(idxTrip, 1)"
										>
											<i class="fa fa-trash fa-fw"></i> {{ _traducao('global', 'remover').toUpperCase() }}
										</button>
									</div>
								</div>
							</div>

							<div class="row" v-if="item.id_aeronave != ''">
								<div class="col-md-1 col-xs-1"></div>
								<div class="col-md-3 col-xs-11">
									<button class="btn btn-sm btn-block btn-info" @click="clickAddTripulacao(index)" type="button">
										<i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarTripulacao').toUpperCase() }}
									</button>
								</div>
							</div>

							<hr />
						</div>

						<div class="row">
							<div class="col-xs-12 col-md-3">
								<button class="btn btn-sm btn-block btn-info" title="Adicionar aeronave" @click="clickAddAero()" type="button">
									<i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarAeronave').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>

					<!-- BTN SALVAR -->
					<div>
						<div class="row" style="margin-bottom: 20px">
							<hr style="margin-top: 2px; margin-bottom: 20px; margin-top: 20px" />
							<div class="col-lg-10 col-xs-9"></div>
							<div class="col-lg-2 col-xs-12">
								<button
									type="button"
									:disabled="desabilitarSalvar"
									@click="clickSalva"
									class="btn btn-block btn-success pull-right"
								>
									<i class="fa fa-check" aria-hidden="true"></i> {{ _traducao('global', 'salvar').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- modal com a lista de ordem de missao -->
			<modal ref="modalOrdem">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalOrdem.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaOrdemDeMissao').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'selecioneOrdemMissaoAbaixo') }}.

							<button
								class="btn btn-xs pull-right"
								:class="{'btn-default': !exibirEncerradas, 'btn-success': exibirEncerradas}"
								@click="exibirEncerradas = !exibirEncerradas"
							>
								<i v-if="!exibirEncerradas" class="fa fa-fw fa-circle-o"></i>
								<i v-if="exibirEncerradas" class="fa fa-fw fa-check-circle"></i>
								{{ _traducao('global', 'exibirEncerradas') }}
							</button>
						</p>
					</div>
				</div>

				<div v-show="ordens.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaOrdem"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table class="table table-lista table-striped table-siga table-hover">
									<thead>
										<tr>
											<th style="width: 10%">
												{{ _traducao('global', 'status') }}
											</th>
											<th style="width: 20%">
												{{ _traducao('global', 'ordemDeMissao') }}
											</th>
											<th>{{ _traducao('global', 'solicitacao') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'inicio') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'cadastro') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaOrdem(item)"
											v-show="!exibirEncerradas ? item.status.toUpperCase() == 'EM EXECUÇÃO' : item.status != ''"
											v-for="(item, idxT) in _ordens"
											:key="idxT"
										>
											<td>
												<span v-if="item.status.toUpperCase() == 'ABERTA'">
													<div class="text-info">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'aberta').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'EM EXECUÇÃO'">
													<div class="text-info">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'emExecucao').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'ENCERRADA'">
													<div class="text-success">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'encerrada').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'CANCELADA'">
													<div class="text-danger">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo }}
												<br />
												<small>{{ item.descricao_ordem }}</small>
											</td>
											<td style="max-width: 400px; white-space: inherit">
												<span v-if="item.descricao_solicitacao == ''">{{
													_traducao('global', 'semSolicitacao').toUpperCase()
												}}</span>
												{{ item.codigo_solicitacao }}
												<br />
												<small>{{ item.descricao_solicitacao }}</small>
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
											<td>
												{{ item.data_inicio | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- modal com a lista de solicitações -->
			<modal ref="modalSolicitacao">
				<button type="button" class="close" @click="$refs.modalSolicitacao.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaOrdemDeMissao').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'selecioneOrdemMissaoAbaixo') }}.
						</p>
					</div>
				</div>

				<div v-show="solicitacoes.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaSolicitacao"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table class="table table-lista table-striped table-siga table-hover">
									<thead>
										<tr>
											<th>{{ _traducao('global', 'codigo') }}</th>
											<th>{{ _traducao('global', 'solicitacao') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaSolicitacao(item)"
											v-for="(item, idxT) in _solicitacoes"
											:key="idxT"
										>
											<td>
												{{ item.codigo }}
											</td>
											<td style="max-width: 400px; white-space: inherit">
												{{ item.descricao_solicitacao }}
												<br />
												<br />
												<small
													><strong>{{ _traducao('global', 'Por').toUpperCase() }}:</strong> {{ item.nome_usuario_inseriu }}</small
												>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- <pre>{{_ordens}}</pre> -->
						</div>
					</div>
				</div>
			</modal>

			<!-- modal com a lista de prevenções -->
			<modal ref="modalPrevencao">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalPrevencao.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaPrevencaoQualificada').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i
							>{{ _traducao('global', 'selecioneAPrevencaoQualificadaAbaixo').toUpperCase() }}
						</p>
					</div>
				</div>

				<div class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaPrevencao"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table class="table table-lista table-striped table-siga table-hover">
									<thead>
										<tr>
											<th style="width: 10%">
												{{ _traducao('global', 'status') }}
											</th>
											<th style="width: 20%">
												{{ _traducao('global', 'prevencaoQualificada') }}
											</th>
											<!-- <th>Solicitação</th> -->
											<th style="width: 10%">{{ _traducao('global', 'inicio') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'fim') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'cadastro') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaPrevencao(item)"
											v-for="(item, idxT) in _prevencao"
											:key="idxT"
										>
											<td>
												<span v-if="item.status == 'A'">
													<div class="text-info">
														{{ _traducao('global', 'ativo').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'C'">
													<div class="text-danger">
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'F'">
													<div class="text-success">
														{{ _traducao('global', 'fechado').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo_prevencao }}
												<br />
												<small>{{ item.descricao }}</small>
											</td>
											<td>
												{{ item.inicio_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.fim_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- MODAL SOLICITACAO OK -->
			<modal ref="modalOk">
				<button type="button" class="close" @click="$refs.modalOk.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'despacho').toUpperCase() }}
				</h4>

				<hr />

				<h2 class="text-center text-success">
					<i class="fa fa-check-circle"></i> {{ _traducao('global', 'despachoSalvo').toUpperCase() }}
				</h2>

				<h2 class="text-center">
					{{ _traducao('global', 'numero').toUpperCase() }}: <br /><strong>{{ form.numero }}</strong>
				</h2>

				<button
					class="btn btn-default"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						voltaLista()
					"
				>
					<i class="icon-left"></i> {{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
				</button>

				<button
					class="btn btn-default pull-right"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						clickPrint(300)
					"
				>
					<i class="icon-imprimir"></i> {{ _traducao('global', 'imprimir') }}
				</button>
			</modal>

			<div class="print">
				<flPrint ref="printCadastro" />
			</div>
		</div>

		<div v-if="visualizar">
			<!-- cabecalho -->
			<div class="fl-cabecalho no-print" v-if="cabecalho">
				<div class="row">
					<div class="col-md-4 col-xs-12">
						<i class="icon icon-desapacho_aeronaves"></i>
						<h3>{{ _traducao('global', 'despacho').toUpperCase() }}</h3>
						<h4>{{ _traducao('menuMonitoramento', 'menuMonitoraAeronaves').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<i class="icon icon-vizualizar icon-sub"></i>
						<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
						<h4>{{ _traducao('global', 'despacho').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<button @click="voltaLista()" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
							<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
						</button>

						<button
							class="btn btn-default pull-right btn-lg"
							:title="_traducao('global', 'imprimir')"
							style="margin-right: 20px"
							@click="_print()"
						>
							<i class="icon-imprimir" style="font-size: 18px"></i>
						</button>
					</div>
				</div>
			</div>

			<flPrint ref="printVisualizar" />
		</div>
	</div>
</template>

<script>
import flPrint from './print.vue'

export default {
	components: {flPrint},

	props: {
		visualizar: {
			required: true,
			type: Boolean
		},

		cabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		aeronaves: {
			type: Array
		},

		contextos: {
			type: Array
		},

		subclassificacoes: {
			type: Array
		}
	},

	computed: {
		editando() {
			return this.form.id == 0 ? false : true
		},

		_solicitacoes() {
			if (this.buscaSolicitacao == '') {
				return _.orderBy(this.solicitacoes, ['codigo'], ['desc'])
			}

			var list = this.solicitacoes.filter((cust) => {
				return (
					cust.descricao_solicitacao.toLowerCase().indexOf(this.buscaSolicitacao.toLowerCase()) >= 0 ||
					cust.codigo.toLowerCase().indexOf(this.buscaSolicitacao.toLowerCase()) >= 0 ||
					cust.nome_usuario_inseriu.toLowerCase().indexOf(this.buscaSolicitacao.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		},

		_ordens() {
			if (this.buscaOrdem == '') {
				return _.orderBy(this.ordens, ['codigo'], ['desc'])
			}
			var list = this.ordens.filter((cust) => {
				return (
					cust.status.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0 ||
					cust.codigo.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0 ||
					cust.descricao_ordem.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
				)
				cust.codigo_solicitacao.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
				cust.descricao_solicitacao.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		},

		_prevencao() {
			let l = _.filter(this.prevencoes, (item) => {
				return item.status != 'C'
			})

			if (this.buscaPrevencao == '') {
				return _.orderBy(l, ['codigo'], ['desc'])
			}

			var self = this
			var list = l.filter(function (cust) {
				return (
					cust.status.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.codigo_prevencao.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.descricao.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		}
	},

	data() {
		return {
			buscaSolicitacao: '',
			desabilitarSalvar: false,

			//dados do mapa
			loadAero: true,
			exibirEncerradas: false,
			//aeronaves: [],
			modal: false,
			ordens: [],
			prevencoes: [],
			buscaOrdem: '',
			buscaPrevencao: '',
			bases: [],
			solicitacoes: [],

			ver: false,
			//subclassificacoes: [],
			//contextos: [],

			id_aeronave: null,

			atualiza_ordem: false,

			form: {
				id: 0,
				aeronave: [
					{
						id_aeronave: '',
						erro: '',
						novo: true,
						tripulacao: [],
						base: '',
						erroBase: ''
					}
				],

				prevencao_inicio: '',
				prevencao_fim: '',
				id_prevencao_qualificada: '',
				prevencao_codigo: '',
				prevencao_descricao: '',

				id_solicitacao: '',
				solicitacao_codigo: '',
				solicitacao_descricao: '',

				nome_usuario_inseriu: '',
				data_cadastro: '',
				ordem_data_inicio: '',
				ordem_codigo: '',
				ordem_descricao: '',
				id_ordem_missao: '',
				tipo: '',
				_tipo: '',
				id_usuario: '',
				base: '',
				numero: '',
				status: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				numero_atividade: '',
				subclassificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				relatorio_voo_trecho: [],
				id_tipo_missao: '0',
				data_hora_apresentacao: ''
			},
			erro: {
				id_aeronave: '',
				tipo: '',
				base: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				subclassificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: ''
			}
		}
	},

	mounted() {
		this.form.id_usuario = $sessao.getId()
		this._providerBaseOperacional((lista) => (this.bases = lista))
		this.carregaTiposMissao()
	},

	methods: {
		novo() {
			//this.addTripulacao(0)
		},

		carregaTiposMissao() {
			this._httpGet('/Tipo_missao/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.tipos_missao = retorno.lista
				}
			})
		},

		clickAddTripulacao(index) {
			this.form.aeronave[index].tripulacao.push({
				trigrama: '',
				nome: '',
				erroTrigrama: '',
				funcao: '',
				erroFuncao: '',
				usuarios: [],
				load: false
			})
		},

		addTripulacao(index) {
			if (this.form.aeronave[index].novo) {
				this.form.aeronave[index].tripulacao.push({
					nome: '',
					trigrama: '',
					erroTrigrama: '',
					funcao: 'Piloto em Comando',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 0, 'Piloto em Comando', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: 'Copiloto',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 1, 'Copiloto', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					erroTrigrama: '',
					funcao: 'Operador Aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 2, 'Operador Aerotático', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: 'Operador Aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 3, 'Operador Aerotático', true)

				this.form.aeronave[index].novo = false
			}
		},

		carregaUsuariosTripulacao(indexAero, indexTrip, funcao, zeraId) {
			////console.log(funcao, zeraId)
			var idPerfil = 0
			if (funcao != '') {
				this.form.aeronave[indexAero].tripulacao[indexTrip].load = true

				// piloto
				if (funcao == 'Piloto em Comando' || funcao == 'Piloto em Instrução' || funcao == 'Copiloto') {
					idPerfil = 14
				}
				// trip Op
				if (funcao == 'Operador Aerotático') {
					idPerfil = 15
				}

				// mecanico
				if (funcao == 'Mecânico') {
					idPerfil = 16
				}

				//tasa
				if (funcao == 'TAS') {
					idPerfil = 17
				}

				// estagiario
				if (funcao == 'Estagiário') {
					idPerfil = '14%7C15'
				}

				this._httpGet('Usuario/get_by_perfil/' + idPerfil, (retorno) => {
					//console.log(retorno)
					if (retorno._request) {
						this.form.aeronave[indexAero].tripulacao[indexTrip].usuarios = retorno.lista.map((item) => {
							item.descricao = item.trigrama + ' - ' + item.nome
							return item
						})
						this.form.aeronave[indexAero].tripulacao[indexTrip].load = false
						if (zeraId) {
							this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
						} else {
							this.setaNomeTripulante(
								indexAero,
								indexTrip,
								retorno.lista,
								this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario
							)
						}

						this.$forceUpdate()
					}
				})
			}
		},

		setaNomeTripulante(indexAero, indexTrip, usuarios, id_usuario) {
			for (var i in usuarios) {
				if (id_usuario == usuarios[i].id_usuario) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = usuarios[i].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = usuarios[i].trigrama
				}
			}
		},

		setaNomeTripulanteTrigrama(indexAero, indexTrip, usuarios, trigrama) {
			if (trigrama != '' || trigrama != null) {
				this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = trigrama.toUpperCase()

				var idx = _.findIndex(usuarios, function (o) {
					return o.trigrama == trigrama.toUpperCase()
				})

				if (idx >= 0) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = usuarios[idx].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = usuarios[idx].id_usuario
				} else {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = ''
				}
			} else {
				this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
				this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
			}
		},

		novoModal(aeronave) {
			this.modal = true
			this.form.aeronave = []
			this.id_aeronave = aeronave.id
			this.form.aeronave.push({
				id_aeronave: aeronave.id,
				erro: '',
				novo: true,
				base: '',
				erroBase: '',
				tripulacao: []
			})

			this.addTripulacao(this.form.aeronave.length - 1)
		},

		editar(item) {
			this.carrega(item)
		},

		clickAddAero() {
			this.form.aeronave.push({id_aeronave: '', erro: '', tripulacao: [], base: '', erroBase: '', novo: true})
		},

		voltaLista() {
			this.$emit('volta-lista')
		},

		clickSalva() {
			if (this.validaForm()) {
				////console.log(this.form);

				var aeros = Object.assign([], this.form.aeronave)

				const id_tipo_missao = this.form.tipo !== 'P' ? this.form.id_tipo_missao : ''
				const data_hora_apresentacao =
					this.form.tipo !== 'P'
						? this._dateTimeToDateSQL(this.form.data_hora_apresentacao, window.$sessao.getDateFormat() + ' HH:MM')
						: ''

				var data = {
					id: this.form.id,
					aeronave: aeros.map((item) => {
						var trips = []
						for (var i in item.tripulacao) {
							if (item.tripulacao[i].trigrama != '') {
								item.tripulacao[i].usuarios = []
								trips.push(item.tripulacao[i])
							}
						}
						item.tripulacao = trips
						return item
					}),
					id_usuario: $sessao.getId(),
					base: this.form.base,
					data_inicio: this._dateTimeToDateSQL(this.form.data_inicio, $sessao.getDateFormat() + ' HH:MM'),
					reds: this.form.numero_bo,
					chamada: this.form.numero_chamada,
					atividade: this.form.numero_atividade,
					id_subclassificacao: this.form.subclassificacao.id,
					houve_contexto: this.form.houve_contexto,
					id_contexto_operativo: this.form.houve_contexto == 1 ? this.form.contexto_operativo.id : '',
					historico: this.form.historico,
					id_ordem_missao: this.form.id_ordem_missao,
					id_prevencao_qualificada: this.form.id_prevencao_qualificada,
					tipo: this.form.tipo,
					ordem_descricao: this.form.ordem_descricao,
					ordem_codigo: this.form.ordem_codigo,
					ordem_data_inicio: this.form.ordem_data_inicio,
					atualiza_ordem: this.atualiza_ordem,
					id_solicitacao: this.form.id_solicitacao,
					solicitacao_codigo: this.form.solicitacao_codigo,
					solicitacao_descricao: this.form.solicitacao_descricao,

					prevencao_inicio: this.form.prevencao_inicio,
					prevencao_fim: this.form.prevencao_inicio,
					id_prevencao_qualificada: this.form.id_prevencao_qualificada,
					prevencao_codigo: this.form.prevencao_codigo,
					prevencao_descricao: this.form.prevencao_descricao,
					id_tipo_missao,
					data_hora_apresentacao
					// voo_instrucao: this.form.voo_instrucao
				}

				console.log('estou lhe enviando:', data)

				//return false

				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
				this._httpPost('mg-siga/Despacho_emergencial/salvar', data, (response) => {
					bus.$emit('load-out')
					if (response._request && response._status) {
						this.desabilitarSalvar = true
						this.form.numero = response.lista.numero
						this.form.id = response.lista.id
						if (!this.modal) {
							this.$refs.modalOk.modalShow(60)
						}

						this.$emit('despacho-add', response.lista)
					}
				})
			} else {
				bus.$emit('exibir-notificacao', {text: this._traducao('menuEscala', 'menuEvermelho'), type: 'danger'})
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			this.form.aeronave = this.form.aeronave.map((item, index) => {
				if (item.id_aeronave == '') {
					passou = false
					item.erro = obrigatorio
				} else {
					item.erro = ''

					for (var i in this.form.aeronave) {
						if (this.form.aeronave[i].id_aeronave == item.id && index != i) {
							item.erro = 'Esssa aeronave está duplicada.'
							passou = false
						}
					}
				}

				if (item.base == '') {
					passou = false
					item.erroBase = obrigatorio
				} else {
					item.erroBase = ''
				}

				if (item.tripulacao.length > 0) {
					if (item.tripulacao[0].trigrama == '') {
						item.tripulacao[0].erroTrigrama = 'Obrigatório.'
						passou = false
					} else {
						item.tripulacao[0].erroTrigrama = ''
					}
				}

				return item
			})

			if (this.form.data_inicio == '') {
				this.erro.data_inicio = obrigatorio
				passou = false
			} else {
				this.erro.data_inicio = ''
			}

			if (this.form.historico == '') {
				this.erro.historico = obrigatorio
				passou = false
			} else {
				this.erro.historico = ''
			}

			// subclassificacao
			if (!this.form.subclassificacao) {
				this.erro.subclassificacao = obrigatorio
				passou = false
			} else {
				this.erro.subclassificacao = ''
			}

			if (this._idCliente != 18) {
				if (this.form.numero_chamada == '' && this.form.tipo != 'Q') {
					this.erro.numero_chamada = obrigatorio
					passou = false
				} else {
					this.erro.numero_chamada = ''
				}
			}

			// houve contexto
			if (this.form.houve_contexto == '') {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}

			return passou
		},

		carrega(item) {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			this._httpGet('mg-siga/Despacho_emergencial/get/' + item.id, (retorno) => {
				bus.$emit('load-out')

				console.log('retorno editar', retorno)

				if (retorno._request && retorno._status) {
					this.form.id = retorno.lista.id
					this.form.aeronave = retorno.lista.aeronave.map((o) => {
						o.erro = ''
						o.erroBase = ''
						o.tripulacao = o.tripulacao.map((trip) => {
							trip.erroTrigrama = ''
							trip.erroFuncao = ''
							trip.load = true
							trip.novo = false
							trip.usuarios = []
							return trip
						})

						return o
					})

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(j, i, this.form.aeronave[j].tripulacao[i].funcao, false)
						}
					}

					this.form.inicio_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.inicio_prevencao
					this.form.fim_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.fim_prevencao
					this.form.codigo_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.codigo_prevencao
					this.form.descricao_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.descricao
					this.form.base = retorno.lista.base == null ? '' : retorno.lista.base
					this.form.data_inicio = this._SQLDateToDateTime(retorno.lista.data_inicio, $sessao.getDateFormat() + ' HH:MM')
					this.form.numero_bo = retorno.lista.reds
					this.form.numero_chamada = retorno.lista.chamada
					this.form._tipo = retorno.lista._tipo
					this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
					this.form.data_cadastro = retorno.lista.data_cadastro
					this.form.numero_atividade = retorno.lista.atividade
					this.form.houve_contexto = retorno.lista.houve_contexto
					this.form.historico = retorno.lista.historico
					this.form.numero = retorno.lista.numero
					this.form.id_solicitacao = retorno.lista.id_solicitacao == null ? '' : retorno.lista.id_solicitacao
					this.form.solicitacao_descricao = retorno.lista.solicitacao_descricao == null ? '' : retorno.lista.solicitacao_descricao
					this.form.solicitacao_codigo = retorno.lista.solicitacao_codigo == null ? '' : retorno.lista.solicitacao_codigo

					if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
						this.form.relatorio_voo_trecho = retorno.lista.relatorio_voo_trecho
					} else {
						this.form.relatorio_voo_trecho = []
					}

					this.form.prevencao_inicio = retorno.lista.prevencao_inicio
					this.form.prevencao_fim = retorno.lista.prevencao_inicio
					this.form.id_prevencao_qualificada = retorno.lista.id_prevencao_qualificada
					this.form.prevencao_codigo = retorno.lista.prevencao_codigo
					this.form.prevencao_descricao = retorno.lista.prevencao_descricao

					this.form.status = retorno.lista.status
					this.form.id_ordem_missao = retorno.lista.id_ordem_missao
					this.form.tipo = retorno.lista.tipo
					this.form.ordem_descricao = retorno.lista.ordem_descricao
					this.form.ordem_codigo = retorno.lista.ordem_codigo
					this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio

					this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
						return o.id == retorno.lista.id_subclassificacao
					})
					// this.form.voo_instrucao = retorno.lista.voo_instrucao

					if (this.form.houve_contexto == 1) {
						this.form.contexto_operativo = _.find(this.contextos, (o) => {
							return o.id == retorno.lista.id_contexto_operativo
						})
					}

					console.log('form antes carrega dados', this.form)

					if (this.form.tipo == 'Q') {
						this.carregaPrevencao()
					}

					if (this.visualizar) {
						this.$refs.printVisualizar.carregaDados(this.form)
					}
				}
			})
		},

		clickAddSolicitacao() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			this._httpGet('mg-siga/Solicitacao/get_aprovada/' + $sessao.getId(), (retorno) => {
				bus.$emit('load-out')

				console.log('retorno', retorno)

				if (retorno._request && retorno._status) {
					this.solicitacoes = retorno.lista.map((item) => {
						return item
					})

					this.$refs.modalSolicitacao.modalShow()
				}
			})
		},

		clickSetaTipo(tipo) {
			// limpa todos os campos referente ao despacho
			this.form.id_ordem_missao = ''
			this.form.ordem_codigo = ''
			this.form.ordem_descricao = ''
			this.form.ordem_data_inicio = ''

			this.form.prevencao_inicio = ''
			this.form.prevencao_fim = ''
			this.form.prevencao_codigo = ''
			this.form.prevencao_descricao = ''
			this.form.id_prevencao_qualificada = ''

			this.form.id_solicitacao = ''
			this.form.solicitacao_codigo = ''
			this.form.solicitacao_descricao = ''

			this.form.tipo = tipo

			if (tipo == 'P') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet('mg-siga/Ordem_missao/get_execucao/' + $sessao.getId(), (retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.ordens = retorno.lista.map((item) => {
							item.status = item.status == null ? '' : item.status
							item.codigo = item.codigo == null ? '' : item.codigo
							item.descricao_ordem = item.descricao_ordem == null ? '' : item.descricao_ordem
							item.codigo_solicitacao = item.codigo_solicitacao == null ? '' : item.codigo_solicitacao
							item.descricao_solicitacao = item.descricao_solicitacao == null ? '' : item.descricao_solicitacao

							return item
						})
						this.$refs.modalOrdem.modalShow()
					}
				})
			} else if (tipo == 'Q') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet('Prevencao_qualificada/get', (retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.prevencoes = retorno.lista
						this.$refs.modalPrevencao.modalShow()
					}
				})
			}
		},

		clickSetaOrdem(ordem) {
			if (this.form.id != 0) {
				this.atualiza_ordem = true
			}

			this.form.id_ordem_missao = ordem.id
			this.form.ordem_codigo = ordem.codigo
			this.form.ordem_descricao = ordem.descricao_ordem
			this.form.ordem_data_inicio = ordem.data_inicio

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet('mg-siga/Ordem_missao/editar/' + ordem.id, (retorno) => {
				if (retorno._request) {
					bus.$emit('load-out')

					this.$refs.modalOrdem.modalHide()
					//console.log(retorno)

					this.form.subclassificacao =
						retorno.id_subclassificacao != null ? this.getSubclassificacaoById(retorno.id_subclassificacao) : ''
					for (var i in retorno.aeronave) {
						this.form.aeronave = []
						this.form.aeronave.push({
							id_aeronave: retorno.aeronave[i].id_aeronave,
							voo_instrucao: retorno.aeronave[i].voo_instrucao,
							base: retorno.aeronave[i].base,
							erroBase: '',
							erro: '',
							tripulacao: retorno.aeronave[i].tripulacao.map((item) => {
								item.erroTrigrama = ''
								item.erroFuncao = ''
								item.usuarios = []
								item.load = true
								item.novo = false
								return item
							})
						})
					}

					console.log('aero', this.form.aeronave)

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(j, i, this.form.aeronave[j].tripulacao[i].funcao, false)
						}
					}

					this.form.houve_contexto = retorno.houve_contexto
					this.form.base = retorno.base

					this.form.historico = ordem.descricao_solicitacao

					// se tiver adendo
					if (retorno.descricao_solicitacao != '') {
						this.form.historico += ' ADENDO: ' + retorno.descricao_solicitacao
					}

					if (this.form.houve_contexto == '1') {
						for (var i in this.contextos) {
							if (this.contextos[i].id == retorno.id_contexto_operativo) {
								this.form.contexto_operativo = this.contextos[i]
							}
						}
					}
				}
			})
		},

		clickSetaSolicitacao(solicitacao) {
			this.form.id_solicitacao = solicitacao.id
			this.form.solicitacao_codigo = solicitacao.codigo
			this.form.solicitacao_descricao = solicitacao.descricao_solicitacao
			this.$refs.modalSolicitacao.modalHide()
		},

		clickSetaPrevencao(prevencao) {
			this.form.prevencao_inicio = prevencao.inicio_prevencao
			this.form.prevencao_fim = prevencao.fim_prevencao
			this.form.prevencao_codigo = prevencao.codigo_prevencao
			this.form.prevencao_descricao = prevencao.descricao
			this.form.id_prevencao_qualificada = prevencao.id
			this.form.historico = prevencao.descricao

			this.$refs.modalPrevencao.modalHide()
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		carregaBase(descricao) {
			for (var i = 0; i < this.bases.length; i++) {
				if (descricao == this.bases[i].descricao) {
					this.form.aeronave[0].base = this.bases[i].id
				}
			}
		},

		clickPrint(tempo) {
			setTimeout(() => {
				this.$refs.printCadastro.carregaDados(this.form)
				this.$nextTick(() => {
					this._print()
				})
			}, tempo)
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>